import payment from "@/plugins/api/factories/Payment";

export const state = {
  paymentResponse: null,
  paymentData: {
    amount: null,
    app_id: process.env.VUE_APP_EASYPAY_APP_ID,
    ls: null,
    save_card: false,
    card_token: null,
    saved_card_id: null,
    name_app_id: "",
  },
  // Добавляем отдельные суммы для разных типов оплаты
  naftogazAmount: 0,
  distributionAmount: 0,
  cards: [],
  paymentUrl: null,
  addCardUrl: null,
  distributionSavedCardResponse: null,
};

export const actions = {
  async getPaymentPage({ commit, state, rootState }) {
    console.log(
      "CHLENIX getPaymentPage REQUEST: " + JSON.stringify(state.paymentData)
    );
    console.log("Отправка запроса на оплату с данными:", {
      amount: state.paymentData.amount,
      ls: state.paymentData.ls,
      card_token: state.paymentData.card_token,
      saved_card_id: state.paymentData.saved_card_id,
      save_card: state.paymentData.save_card
    });
    
    // Если используется сохраненная карта (saved_card_id)
    if (state.paymentData.saved_card_id) {
      console.log("Используется сохраненная карта, вызываем easypay/pay-with-saved-card");
      console.log("Auth token:", rootState.Auth.authToken);
      console.log("User ID:", rootState.Auth.user_id);
      
      // Вызываем easypay/pay-with-saved-card напрямую
      return await payment.payWithSavedCard({
        user_id: rootState.Auth.user_id,
        card_id: state.paymentData.saved_card_id,
        amount: state.paymentData.amount,
        ls: state.paymentData.ls,
        app_id: state.paymentData.app_id,
        name_app_id: state.paymentData.name_app_id || rootState.Auth.nativeData?.id || rootState.Auth.app_id,
      }, async (response) => {
        console.log("Ответ от easypay/pay-with-saved-card:", response);
        
        // Проверяем статус оплаты
        if (response.success === true && (response.payment_status === "accepted" || response.status === "accepted")) {
          console.log("Платеж успешен!");
          commit("SET_PAYMENT_RESPONSE", { 
            ...response, 
            mode: 1,
            success: true,
            message: "Оплата прошла успешно!" 
          });
          return;
        }
        
        if (response.success === false || response.payment_status === "declined" || response.status === "declined") {
          const errorMsg = response.decline_reason || response.description || response.error || response.message || "Платіж відхилено";
          console.log("Платеж отклонен:", errorMsg);
          commit("SET_PAYMENT_RESPONSE", { 
            ...response, 
            mode: 0,
            success: false,
            error: errorMsg,
          });
          return;
        }
        
        // Обработка ответа с 3D Secure
        if (response.status === "Need3Ds") {
          console.log("Received 3D Secure response:", response);
          const redirectUrl = response.action || response.alternativeRedirectUrl;
          console.log("3D Secure redirect URL:", redirectUrl);
          commit("SET_PAYMENT_URL", redirectUrl);
          commit("SET_PAYMENT_RESPONSE", { ...response, mode: 3 });
        } else if (response.url) {
          // Обычный ответ с iframe URL
          console.log("Regular payment response:", response);
          commit("SET_PAYMENT_URL", response.url);
          commit("SET_PAYMENT_RESPONSE", response);
        } else {
          // Неизвестный формат ответа
          console.log("Unknown response format:", response);
          commit("SET_PAYMENT_RESPONSE", response);
        }
      });
    }
    
    // Обычная оплата с card_token от EasyPay
    return await payment.getPaymentUrl(state.paymentData, async (response) => {
      console.log(
        "CHLENIX getPaymentUrl response: " + JSON.stringify(response)
      );

      // Обработка ответа с 3D Secure
      if (response.status === "Need3Ds") {
        console.log("Received 3D Secure response:", response);
        // Используем action или alternativeRedirectUrl для перенаправления
        const redirectUrl = response.action || response.alternativeRedirectUrl;
        console.log("3D Secure redirect URL:", redirectUrl);
        commit("SET_PAYMENT_URL", redirectUrl);
        commit("SET_PAYMENT_RESPONSE", { ...response, mode: 3 }); // Устанавливаем специальный режим для 3D Secure
      } else {
        // Обычный ответ
        console.log("Regular payment response:", response);
        commit("SET_PAYMENT_URL", response.url);
        commit("SET_PAYMENT_RESPONSE", response);
      }
    });
  },
  async payDistributionWithSavedCard({ commit, rootState }, { savedCardId, ls, amount, serviceKey }) {
    const requestPayload = {
      user_id: rootState.Auth.user_id,
      saved_card_id: savedCardId,
      ls: ls,
      amount: amount,
      service_key: serviceKey,
    };
    console.log("payDistributionWithSavedCard REQUEST PAYLOAD:", JSON.stringify(requestPayload));

    return await payment.payDistributionWithSavedCard(requestPayload, async (response) => {
      console.log("payDistributionWithSavedCard response:", response);

      let normalized;

      if (response.partial_success === true) {
        normalized = {
          ...response,
          mode: 2,
          success: false,
          partial_success: true,
          paymentTarget: "distribution",
          message: response.message || "Оплата за газ успішна. Оплату за розподілення не підтверджено.",
        };
      } else if (response.success === true && (response.payment_status === "accepted" || response.status === "accepted")) {
        normalized = { ...response, mode: 1, success: true, paymentTarget: "distribution" };
      } else if (response.success === false || response.payment_status === "declined" || response.status === "declined") {
        const errorMsg = response.decline_reason || response.description || response.error || response.message || "Платіж розподілу відхилено";
        normalized = { ...response, mode: 0, success: false, paymentTarget: "distribution", error: errorMsg };
      } else if (response.status === "Need3Ds") {
        normalized = { ...response, mode: 3, paymentTarget: "distribution" };
      } else {
        normalized = { ...response, paymentTarget: "distribution" };
      }

      commit("SET_DISTRIBUTION_SAVED_CARD_RESPONSE", normalized);
      return normalized;
    });
  },

  async getCardsList({ commit, rootState }) {
    const userId = rootState.Auth.user_id;
    
    await payment.getSavedCards({ user_id: userId }, (response) => {
      console.log("Ответ от stripe/get-saved-cards:", response);
      
      if (response && response.success && response.cards) {
        const formattedCards = response.cards.map(card => ({
          pan: card.masked,
          masked: card.masked,
          card_token: String(card.id),
          id: card.id,
          brand: card.brand,
          expiry: card.expiry,
          created_at: card.created_at
        }));
        
        console.log("Отформатированный список карт:", formattedCards);
        commit("SET_PAYMENT_CARDS", formattedCards);
      } else {
        commit("SET_PAYMENT_CARDS", []);
      }
    });
  },
  async deleteCard(store, cardToken) {
    return await payment.deleteCard({ card_token: cardToken }, (res) => {
      return res;
    });
  },
  async getSaveCardPage({ commit }) {
    await payment.getEasyPaySaveCardsPage((response) => {
      console.log("CHLENIX getEasyPaySaveCardsPage: " + response.url);
      commit("SET_ADD_CARD_URL", response.url);
    });
  },
  async saveCardWithFullData(store, cardData) {
    return await payment.saveCardWithFullData(cardData, (response) => {
      console.log("saveCardWithFullData response:", response);
      return response;
    });
  },
  async saveCardWithStripeToken(store, data) {
    return await payment.saveCardWithStripeToken(data, (response) => {
      console.log("saveCardWithStripeToken response:", response);
      return response;
    });
  },
  async getStripeUrl(store, stripeData) {
    return await payment.getStripe({ stripeData }, (res) => {
      return res;
    });
  },
  async cancelSubscription(store, stripeData) {
    return await payment.cancelSubscription({ stripeData }, (res) => {
      return res;
    });
  },
  async createSubscriptionDirect(store, stripeData) {
    return await payment.createSubscriptionDirect(stripeData, (res) => {
      console.log(" createSubscriptionDirect res", JSON.stringify(res));
      return res;
    });
  },
};

export const mutations = {
  SET_PAYMENT_RESPONSE(state, response) {
    state.paymentResponse = response;
  },
  SET_PAYMENT_CARDS(state, cards) {
    state.cards = cards;
  },
  SET_CARD_TOKEN(state, token) {
    const cardId = parseInt(token);
    state.paymentData.card_token = isNaN(cardId) ? token : null;
    state.paymentData.saved_card_id = isNaN(cardId) ? null : cardId;
    
    console.log("SET_CARD_TOKEN вызван с:", token);
    console.log("Установлено card_token:", state.paymentData.card_token);
    console.log("Установлено saved_card_id:", state.paymentData.saved_card_id);
  },
  SET_DISTRIBUTION_SAVED_CARD_RESPONSE(state, response) {
    state.distributionSavedCardResponse = response;
  },
  SET_SAVE_CARD(state, type) {
    state.paymentData.save_card = type;
  },
  SET_PAYMENT_URL(state, url) {
    state.paymentUrl = url;
  },
  UPDATE_AMOUNT(state, amount) {
    state.paymentData.amount = amount <= 0 ? 10 : amount;
  },
  SET_USER_LS(state, ls) {
    state.paymentData.ls = ls;
  },
  SET_NAME_APP_ID(state, name_app_id) {
    state.paymentData.name_app_id = name_app_id;
    console.log(
      "SET_NAME_APP_ID: " + JSON.stringify(state.paymentData.name_app_id)
    );
  },
  SET_ADD_CARD_URL(state, url) {
    state.addCardUrl = url;
    console.log(
      "CHLENIX SET_ADD_CARD_URL: " + JSON.stringify(state.addCardUrl)
    );
  },
  // Мутации для работы с разделенными суммами оплаты
  SET_NAFTOGAZ_AMOUNT(state, amount) {
    state.naftogazAmount = amount;
    console.log("SET_NAFTOGAZ_AMOUNT: " + amount);
  },
  SET_DISTRIBUTION_AMOUNT(state, amount) {
    state.distributionAmount = amount;
    console.log("SET_DISTRIBUTION_AMOUNT: " + amount);
  },
};
